<template>
  <el-container class="con">
    <el-main>
      <img class="img_logo" src="@/assets/images/logo.png" alt=""/>
      <img class="img_osp" src="@/assets/images/background_osp.png" alt=""/>
      <p class="p1">Hi，你好！</p>
      <p class="p2">欢迎进入<br>
        网络渠道销售与支付(OSP)平台
      </p>
      <div class="div">
        <img class="img_login" src="@/assets/images/login_osp.png" alt=""/>
        <img class="img_oval_1" src="@/assets/images/oval_1.png" alt=""/>
        <img class="img_oval_2" src="@/assets/images/oval_2.png" alt=""/>
        <p class="p3">小禾订货平台</p>
        <el-input class="input" prefix-icon="el-icon-user" v-model="loginForm.username" placeholder="请输入用户名" :disabled="loading"></el-input>
        <el-input class="input" type="password" show-password prefix-icon="el-icon-unlock" v-model="loginForm.password" placeholder="请输入密码" :disabled="loading"></el-input><br>
        <el-button class="but" @click="doLogin" :disabled="loading">
          <span v-if="!loading" class="sp">登录</span>
          <span v-if="loading" class="sp">登录中<i class="el-icon-loading"></i></span>
        </el-button>
        <el-button class="but" @click="doRegister" :disabled="loading">
          <span class="sp">立即注册</span>
        </el-button>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data () {
    return {
      loginForm: {
        tenantId: '603609',
        username: '',
        password: ''
      },
      loading: false
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
    isFinancer : {
      get() {
        let isFinancer = false;
        for (let org of this.currentUser.adminOrgs) {
          if (org.name !== null && org.name.contains('财务')) {
            isFinancer = true;
          }
        }
        return isFinancer;
      }
    }
  },
  methods: {
    doLogin() {
      this.loading = true;
      if(!this.loginForm.tenantId) {
        this.$modal.msgError("租户编号不能为空");
        this.loading = false;
        return;
      }
      if(!this.loginForm.username) {
        this.$modal.msgError("用户名不能为空");
        this.loading = false;
        return;
      }
      if(!this.loginForm.password) {
        this.$modal.msgError("密码不能为空");
        this.loading = false;
        return;
      }
      //四次md5加密
      //let md5_1 = this.$md5(this.loginForm.password).toUpperCase();
      //let md5_2 = this.$md5(md5_1).toUpperCase();
      //let md5_3 = this.$md5(md5_2).toUpperCase();
      //let md5_4 = this.$md5(md5_3).toUpperCase();
      //this.loginForm.password = md5_4;

      this.$store.dispatch("Login", this.loginForm).then(() => {
        this.$store.dispatch("GetUserInfo").then(
          res => {
            // console.log(res.data)
            if(res.data.userSource === 0 || res.data.roles[0].roleKey === 'osp_admin'){ //判断是否是协调员
              //系统用户，不跳转组织选择页面，跳路由第一页
              this.$router.push({ path: this.redirect || "/admin" });
              return;
            }
            // console.log(res.data)
            //判断当登录账户不是财务角色（业务员或客户）跳转公司设置页面
            if(res.data.adminOrgs !== undefined && res.data.adminOrgs !== null){
              for(let adminOrg of res.data.adminOrgs){
                // console.log(adminOrg);
                if(adminOrg.name !== null && adminOrg.name.indexOf('财务') >= 0){
                  //财务角色跳转财务公司配置页面
                  this.$router.push({ path: this.redirect || "/system/company/finance" });
                  localStorage.setItem("isFinancer" , "true");
                  return;
                }
              }
            }
            localStorage.setItem("isFinancer" , "false");
            this.$router.push({ path: this.redirect || "/system/user/company" });
          }
        ).catch(err => {
          console.log(err);
        })
      }).catch(() => {
        this.loading = false;
      });
    },
    doRegister(){
      this.$router.push({ path: "/register" });
    }
  }
};
</script>
<style lang="less" scoped>
  .con{
    background: linear-gradient(180.00deg, rgba(239,49,67,1.00) 0%,rgba(249,105,120,1.00) 100%);
    border-radius: 15px;
    height: 100vh;
  }
  .img_logo{
    width: 200px;
    height: 50px;
  }
  .img_osp{
    position: absolute;
    width: 1500px;
    height: 850px;
    left: -86px;
    top: -180px;
  }
  .p1{
    /* Hi,你好！ */
    position: absolute;
    width: 710px;
    left: 215px;
    top: 380px;

    color: rgb(255, 255, 255);
    font-size: 64px;
    font-weight: 700;
    line-height: 60px;
    letter-spacing: 7px;
    text-align: left;
  }
  .p2{
    /* 欢迎进入 网络渠道销售与支付(OSP)平台 */
    position: absolute;
    width: 710px;
    left: 215px;
    top: 470px;

    color: rgb(255, 255, 255);
    font-size: 32px;
    font-weight: 700;
    line-height: 45px;
    letter-spacing: 1px;
    text-align: left;
  }
  .div{
    /* 矩形 172 */
    position: absolute;
    width: 50vh;
    height: 55vh;
    left: 60%;
    top: 23%;

    background: rgb(255, 255, 255);
    border-radius: 15px;

    text-align: center;
  }
  .img_login{
    position: absolute;
    width: 100px;
    z-index: 3;
    top: 6%;
    left: 40%;
  }
  .img_oval_1{
    position: absolute;
    width: 130px;
    z-index: 1;
    top: 4%;
    left: 35%;
  }
  .img_oval_2{
    position: absolute;
    width: 100px;
    z-index: 2;
    top: 7%;
    left: 39%;
  }
  .p3{
    color: rgb(239, 51, 69);
    font-size: 24px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: center;
    margin-top: 37%;
  }
  .input{
    width: 68%;
    margin-top: 7%;
  }
  .but{
    margin-top: 8%;
    width: 33%;
    height: 44px;
    background: linear-gradient(180.00deg, rgba(243.97,80.92,96.73,1.00) 0%,rgba(253,131,145,1.00) 100%);
    border-radius: 50px;
    border: none;
  }
  .sp{
    color: rgb(255, 255, 255);
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 1px;
    text-align: center;
  }
  .el-button.is-disabled{
    background: linear-gradient(180.00deg, rgba(243.97,80.92,96.73,1.00) 0%,rgba(253,131,145,1.00) 100%);
  }
</style>
